<template>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      permanent
      expand-on-hover
      app
    >
     <v-list-item class="px-2 header_cont">
     <!--div class="head-menu-btn">
      <button class="head-menu__btn" aria-label="メニューを開閉する" title="メニューを開閉する" @click="mini = !mini" >
       <span class="hamburger" v-bind:class="[{'is-active': !mini}]">
        <i></i>
        <i></i>
        <i></i>
       </span>
      </button>
     </div--><!-- /.head-menu-btn -->
      </v-list-item>

      <v-list dense>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :to="item.to"
          :href="item.href"
        >
          <v-list-item-icon>
            <v-icon v-if="item.icon!='./img/favicon/favicon.png'">{{ item.icon }}</v-icon>
			<img :src="item.icon" v-else />
          </v-list-item-icon>

          <v-list-item-content >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
</template>
<script>
  export default {
    computed : {
        routpath : function(){
            return this.$route.path;
        },
    },
    watch : {
        routpath : function(){
            if(this.$route.path != '/confirm' || this.$route.path != '/login')
                this.disp = true;
            else
                this.disp = false;
        },
    },
    data () {
      return {
        drawer: true,
        items: [
          { title: 'HOME', icon: 'mdi-home-city',to : '/' },
          { title: 'スケジュール', icon: 'mdi-calendar-clock',to : '/cal' },
          { title: 'リリース一覧', icon: 'mdi-format-list-bulleted' , to: '/list'},
          { title: '編集', icon: 'mdi-file-edit-outline' , to: '/edit'},
          { title: 'メディア', icon: 'mdi-book-open-page-variant' , to : '/media'},
          { title: 'トレンド', icon: 'mdi-trending-up' , to : '/neta'},
          { title: '設定', icon: 'mdi-cog-outline'  , to : '/config'},
          { title: 'ログアウト', icon: 'mdi-logout' , href : 'https://qlipper.jp/logout'},
          { title: 'Qlipperへ', icon: './img/favicon/favicon.png' , href : 'https://qlipper.jp/top'},
        ],
        mini: true,
      }
    },
    methods : {
        close : function(){
            this.mini = true;
        },
    },
  }

</script>
<style>
.header_cont{
    background-color : #fff;
    border-bottom   : 4px solid #e11e32;
    height : 62px;
}

.head-menu__btn
{
    width:45px!important;
    height:45px!important;
}

.hamburger.is-active i:nth-child(1){
    top: 0px!important;
    left: -2px!important;
    width: 12px!important;
    transform: rotate(-45deg);
}

.hamburger.is-active i:nth-child(3) {
    bottom: -1px!important;
    left: -2px!important;
    width: 12px!important;
    transform: rotate(45deg);
}

.hamburger i:nth-child(2) {
    top: 50%;
    margin-top: -0.4px!important;
}
</style>
